<template>
  <el-dialog
    title="申请退款"
    :visible.sync="dialogVisible"
    width="600px"
    class="dialog"
  >
    <el-form :model="form" label-width="100px">
      <el-form-item label="委托单号">
        {{ order.checkmallOrderMainId }}
      </el-form-item>
      <el-form-item label="仪器名称">
        {{ order.checkmallWaresName }}
      </el-form-item>
      <el-form-item label="退款金额" class="dialog-price">
        ￥{{ order.orderPrice }}
      </el-form-item>
      <el-form-item label="申请退款原因">
        <el-input
          type="textarea"
          :rows="4"
          placeholder="请输入内容"
          v-model="form.refundReason"
        >
        </el-input>
      </el-form-item>
      <template v-if="order.saleStatus">
        <el-form-item label="审核状态"
          >{{ REFUND_STATUS_TEXT[order.saleStatus] }}
        </el-form-item>
      </template>
      <el-form-item label="审核驳回原因" v-if="order.rejectReason"
        >{{ order.rejectReason }}
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button
        type="primary"
        @click="confirmClick"
        :loading="btnLoading"
        v-if="!order.saleStatus"
        >确 定</el-button
      >
    </span>
  </el-dialog>
</template>
<script>
import { applyRefund } from "@/api/userCenter";
import { REFUND_STATUS_MAP, REFUND_STATUS_TEXT } from "@/constant/dict";
export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    order: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      form: {},
      btnLoading: false,
      REFUND_STATUS_TEXT,
    };
  },
  computed: {
    dialogVisible: {
      get: function () {
        return this.value;
      },
      set: function (val) {
        this.$emit("input", val);
      },
    },
  },
  created() {
    const { refundReason, saleStatus } = this.order;
    if (saleStatus) {
      Object.assign(this.form, {
        refundReason,
      });
    }
  },
  methods: {
    async confirmClick() {
      const { checkmallOrderMainId } = this.order;
      const params = {
        checkmallOrderMainId,
        saleStatus: REFUND_STATUS_MAP.pending,
        ...this.form,
      };
      this.btnLoading = true;
      await this.$axios.put(applyRefund, params).finally(() => {
        this.btnLoading = false;
      });
      this.$message.success("提交成功，等待审核");
      this.$emit("refresh");
      this.dialogVisible = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.dialog {
  ::v-deep .el-form-item {
    margin-bottom: 0px;
  }
  &-price {
    margin-bottom: 10px !important;
  }
  ::v-deep .el-dialog__body {
    padding: 0 20px 10px 20px;
  }
}
</style>
